import { createSelector } from '@/shared/lib/helpers/create-store-logic';

export const [useModals, selectModals] = createSelector((state) => state.modal.data);
